<template>

    <Head :title="option.title" />
    <div class="w-full min-h-screen flex flex-col gap-10">

        <div class="w-full">
            <Header :title="option.title" />
            <div class="flex flex-col my-20   relative justify-center items-center  lg:max-w-[900px]   mx-auto">
                <div class=" w-full">
                    <p v-if="success" class="success-message px-6"
                        style="text-align: start;line-height: 1.2;width: 100%;">
                        Sayın {{ form.name }} {{ form.surname }},<br><br>
                        Türkiye E-Ticaret Ödülleri Başvurunuz Alındı!<br><br>

                        Türkiye E-Ticaret Ödülleri’ne göstermiş olduğunuz ilgi için teşekkür ederiz.
                        Başvurunuz başarıyla tamamlanmıştır.<br><br>

                        Değerlendirme sonuçları ve sonraki aşamalar hakkında e-posta yoluyla
                        bilgilendirme sağlanacaktır.<br><br>

                        Kazananlar, 21 Kasım tarihinde İstanbul Lütfi Kırdar Kongre Merkezi’nde
                        gerçekleşecek Türkiye E-Ticaret Haftası
                        kapsamında düzenlenecek özel törende açıklanacaktır.<br><br>

                        Her adımıyla dijital ticaretin geleceğini birlikte şekillendirdiğimiz bu süreçte
                        yer aldığınız için teşekkür ederiz.<br><br><br><br>

                        <a style="color:#fff;text-decoration: none;"
                            href="mailto:info@turkiyeeticarethaftasi.com">info@turkiyeeticarethaftasi.com</a><br>
                        <a style="color:#fff;text-decoration: none;"
                            href="www.turkiyeeticarethaftasi.com">www.turkiyeeticarethaftasi.com</a><br>
                    </p>
                    <template v-else>

                        <Stepper v-model:value="form.step" class="w-full pr-3 lg:-pr-0">
                            <StepItem value="1">
                                <Step>Kişisel Bilgiler Zorunlu</Step>
                                <StepPanel v-slot="{ activateCallback }">
                                    <div class="flex flex-col  bg-transparent">
                                        <DynamicField @update-data="() => null" v-model:inputs="stepOneData"
                                            v-model:form="form" v-model:option="option"
                                            @set-child="(e, input) => setChild(e, input)"
                                            @set-filter="(e, input) => setFilter(e, input)">
                                        </DynamicField>
                                    </div>
                                    <div class="flex py-6 gap-2">
                                        <Button class="w-24" @click="submitForm(activateCallback, '2')"
                                            :loading="form.processing">
                                            İleri
                                        </Button>
                                    </div>
                                </StepPanel>
                            </StepItem>
                            <StepItem value="2">
                                <Step>İletişim Bilgileri Zorunlu</Step>
                                <StepPanel v-slot="{ activateCallback }">
                                    <div class="flex flex-col  bg-transparent">
                                        <DynamicField @update-data="() => null" v-model:inputs="stepTwoData"
                                            v-model:form="form" v-model:option="option"
                                            @set-child="(e, input) => setChild(e, input)"
                                            @set-filter="(e, input) => setFilter(e, input)">
                                        </DynamicField>
                                    </div>
                                    <div class="flex py-6 gap-2">
                                        <Button label="Geri" class="w-24" severity="secondary"
                                            @click="activateCallback('1')" />
                                        <Button class="w-24" @click="submitForm(activateCallback, '3')"
                                            :loading="form.processing">
                                            İleri
                                        </Button>
                                    </div>
                                </StepPanel>
                            </StepItem>
                            <StepItem value="3">
                                <Step>Kategoriler Zorunlu</Step>
                                <StepPanel v-slot="{ activateCallback }">
                                    <div class="flex flex-col  bg-transparent">
                                        <DynamicField @update-data="() => null" v-model:inputs="stepThreeData"
                                            v-model:form="form" v-model:option="option"
                                            @set-child="(e, input) => setChild(e, input)"
                                            @set-filter="(e, input) => setFilter(e, input)">
                                        </DynamicField>
                                    </div>
                                    <div class="flex py-6 gap-2">
                                        <Button label="Geri" class="w-24" severity="secondary"
                                            @click="activateCallback('2')" />
                                        <Button class="w-24" @click="submitForm(activateCallback, '4')"
                                            :loading="form.processing">
                                            İleri
                                        </Button>
                                    </div>
                                </StepPanel>
                            </StepItem>
                            <StepItem value="4">
                                <Step>Başarı Hikayesi ve Veriler Zorunlu</Step>
                                <StepPanel v-slot="{ activateCallback }">
                                    <div class="flex flex-col  bg-transparent">
                                        <DynamicField @update-data="() => null" v-model:inputs="stepFourData"
                                            v-model:form="form" v-model:option="option"
                                            @set-child="(e, input) => setChild(e, input)"
                                            @set-filter="(e, input) => setFilter(e, input)">
                                        </DynamicField>
                                    </div>
                                    <div class="flex py-6 gap-2">
                                        <Button label="Geri" class="w-24" severity="secondary"
                                            @click="activateCallback('3')" />
                                        <Button class="w-24" @click="submitForm(activateCallback, '5')"
                                            :loading="form.processing">
                                            İleri
                                        </Button>
                                    </div>
                                </StepPanel>
                            </StepItem>
                            <StepItem value="5">
                                <Step>Görsel, Video Materyaller ve Raporlar (Opsiyonel)</Step>
                                <StepPanel v-slot="{ activateCallback }">
                                    <div class="flex flex-col  bg-transparent">
                                        <DynamicField @update-data="() => null" v-model:inputs="stepFiveData"
                                            v-model:form="form" v-model:option="option"
                                            @set-child="(e, input) => setChild(e, input)"
                                            @set-filter="(e, input) => setFilter(e, input)">
                                        </DynamicField>

                                        <div class="flex flex-col mt-4 mb-10">
                                            <div id="example3"></div>
                                            <input id="example3_input" type="hidden" name="r_captcha" />
                                            <Message v-if="form.errors && form.errors.r_captcha" severity="error"
                                                size="small" variant="simple">
                                                {{ form.errors.r_captcha }}
                                            </Message>

                                        </div>
                                    </div>
                                    <div class="flex py-6 gap-2">
                                        <Button label="Geri" class="w-24" severity="secondary"
                                            @click="activateCallback('4')" />
                                        <Button @click="submitForm(activateCallback, '6')" :loading="form.processing">
                                            Başvuruyu Tamamla
                                        </Button>
                                    </div>
                                </StepPanel>
                            </StepItem>

                        </Stepper>


                    </template>

                    <!-- <div
                        class="bg-green-200 flex flex-row justify-center items-center p-6 rounded-md text-green-800 text-lg font-semibold gap-4">
                        <div class="text-4xl">
                            <span class=" mdi mdi-check "> </span>
                        </div>
                        <div>
                            Türkiye E-Ticaret Ödülleri’ne göstermiş olduğunuz ilgi için teşekkür ederiz.<br>
                            Başvuru sürecimiz tamamlanmıştır.
                        </div>
                    </div> -->
                </div>

                <div class=" h-20"></div>
            </div>
        </div>
        <div class=" h-20"></div>

        <Footer></Footer>
    </div>

</template>


<style>
body {
    background: #071b37;


}



.vue-tel-input {
    background-color: white !important;
}



.p-message-text,
.checkbox-text {
    color: #ff0b52 !important;
}


.p-stepper {
    background-color: transparent !important;
}

.p-steplist {
    background-color: transparent !important;
}

.p-steppanels,
.p-steppanel {
    background-color: transparent !important;
}

.helper_hint .p-message-text {
    color: white !important;
}

label,
.checkbox-content,
.success-message,
.hint_text {
    color: white;
}
</style>


<script setup>
import { ref, onMounted, nextTick } from 'vue';
import { Head, useForm, router, Link, usePage } from '@inertiajs/vue3';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { trans as $t, reset } from 'laravel-vue-i18n';
import DynamicField from '@/Builder/Components/DynamicField.vue';
import pkg from 'lodash';
import moment from 'moment';
import collect from 'collect.js';
import Header from '@/Components/Header.vue';
import Footer from '@/Components/Footer.vue';



const date = moment().format('DD.MM.YYYY');
const { debounce } = pkg;
const props = defineProps({
    inputs: {
        type: Array,
        required: true,
    },
    form: {
        type: Object,
        required: true,
    },
    option: {
        type: Object,
        required: true,
    },
});


const reCapcha = ref(null);
const inputs = ref(props.inputs);
const form = useForm(props.form);
const option = ref(props.option);
const visible = ref(false);
const success = ref(false);

var categories = [
    'category', 'text1', 'text2', 'text3', 'text4', 'text5', 'text6', 'text7', 'text8', 'text9', 'text10',
    'text11', 'text12', 'text13', 'text14', 'text15', 'text16', 'text17', 'text18', 'text19', 'text20',
    'text21', 'text22', 'text23', 'text24', 'text25', 'text26', 'text27', 'text28', 'text29', 'text30',
    'text31', 'text32', 'text33', 'text34', 'text35', 'text36', 'text37', 'text38', 'text39', 'text40',
    'text41', 'text42', 'text43', 'text44', 'text45', 'text46', 'text47', 'text48', 'text49'];


const stepOneData = ref(collect(props.inputs).whereIn('column', ['photo', 'name', 'surname', 'position', 'tc_no', 'birthdate', 'email', 'phone']).all());
const stepTwoData = ref(collect(props.inputs).whereIn('column', ['company', 'website', 'state', 'city', 'address']).all());
const stepThreeData = ref(collect(props.inputs).whereIn('column', categories).all());
const stepFourData = ref(collect(props.inputs).whereIn('column', ['text50', 'text51']).all());
const stepFiveData = ref(collect(props.inputs).whereIn('column', ['video_link', 'images', 'files', 'contract', 'verified', 'kvkk']).all());


const dialogCreate = () => {
    form.clearErrors();
    inputs.value.forEach((input, key) => {
        form[input.column] = input.default ?? null;
    });
    form.step = "1";
};



const submitForm = (callback, step) => {
    form.post(`${option.value.url}/store`, {
        onSuccess: (e) => {
            if (step == 6) {
                success.value = true;
            } else {

                form.step = step;
                if (callback) callback(step);
            }
        }
    })
};


const resetForm = () => {
    form.reset();
    form.clearErrors();
    inputs.value.forEach((input, key) => {
        form[input.column] = input.default ?? null;
    });
};

const setChild = (e, input) => {
    if (input.childColumn) {
        form[input.childColumn] = null;
        const url = new URL(window.location.href);
        const params = url.searchParams;
        if (!params.has(input.childColumn)) {
            params.append(input.childColumn, e.value ?? "");
        } else {
            params.set(input.childColumn, e.value ?? "");
        }
        router.get(`${option.value.url}`, params, {
            preserveState: true,
            only: ['inputs'],
            onSuccess: (page) => {
                inputs.value = page.props.inputs;
                stepTwoData.value = collect(page.props.inputs).whereIn('column', ['company', 'website', 'state', 'city', 'address']).all();
                form[input.childColumn] = e.value;
            }
        });
    }
};


const fetchResults = debounce((value, column) => {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    if (!params.has(column)) {
        params.append(column, value);
    } else {
        params.set(column, value);
    }
    router.get(`${option.value.url}`, params, {
        preserveState: true,
        only: ['inputs'],
        onSuccess: (page) => {
            inputs.value = page.props.inputs;
        }
    });
}, 1000);
const setFilter = (e, input) => {
    if (input.filter && input.filterColumn) {
        input.loading = true;
        fetchResults(e.target.value, input.filterColumn);
    }
};











onMounted(() => {
    dialogCreate();
});






</script>
